import CheckIcon from '@mui/icons-material/Check';
import { Dialog, DialogTitle, Fab, Grid, List, ListItemButton, ListItemIcon, ListItemText, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTemplateFontSettings } from 'styles/templateFontSettings';

function RoleUserPartcListDialog({ handleCloseRole, onClose, open, pageTitle }) {

  const [openRoleDialog, setOpenRoleDialog] = useState(false);

  const handleListItemClick = async (roleId) => {
    await handleCloseRole(roleId);
    setOpenRoleDialog(false);
  };

  const handleClose = async () => {
    setOpenRoleDialog(false);
    onClose();
  };

  useEffect(() => {
    if (open === true) {
      setOpenRoleDialog(true);
    }
  }, [open]);

  
  return (
    <React.Fragment>
      <Dialog onClose={handleClose} open={openRoleDialog} maxWidth="xs" fullWidth scroll="paper">
        <DialogTitle sx={{  }}>{pageTitle} / Yetki Seçiniz</DialogTitle>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} lg={12}>
            <List disablePadding>
              <ListItemButton
                component={"li"}
                alignItems={"flex-start"}
                sx={{
                  borderBottom: 1,
                  borderBottomColor: 'divider',
                  px: 3,
                }}
                onClick={() => handleListItemClick(100)}
              >
                <ListItemText
                  primary={<Typography component={"div"}>
                    <Typography variant={"body1"} mb={1} sx={{  }}>
                      Üye Yetkisi
                    </Typography>
                  </Typography>} />
                <ListItemIcon
                  sx={{
                    position: 'absolute',
                    right: 10,
                    bottom: 6,
                    transition: 'all 0.2s',
                  }}
                >
                  <Fab size="small" color={"primary"} sx={{
                    bgcolor: 'grey.300',
                    '&:hover': {
                      bgcolor: (theme) => theme.palette.primary.main
                    },
                    width: 35,
                    height: 35,
                    minHeight: 35,
                    '& .MuiSvgIcon-root': {
                      fontSize: '1rem'
                    }
                  }}><CheckIcon /></Fab>
                </ListItemIcon>
              </ListItemButton>

              <ListItemButton
                component={"li"}
                alignItems={"flex-start"}
                sx={{
                  borderBottom: 1,
                  borderBottomColor: 'divider',
                  px: 3,
                }}
                onClick={() => handleListItemClick(104)}
              >
                <ListItemText
                  primary={<Typography component={"div"}>
                    <Typography variant={"body1"} mb={1} sx={{  }}>
                      Katılımcı Yetkisi
                    </Typography>
                  </Typography>} />
                <ListItemIcon
                  sx={{
                    position: 'absolute',
                    right: 10,
                    bottom: 6,
                    transition: 'all 0.2s',
                  }}
                >
                  <Fab size="small" color={"primary"} sx={{
                    bgcolor: 'grey.300',
                    '&:hover': {
                      bgcolor: (theme) => theme.palette.primary.main
                    },
                    width: 35,
                    height: 35,
                    minHeight: 35,
                    '& .MuiSvgIcon-root': {
                      fontSize: '1rem'
                    }
                  }}><CheckIcon /></Fab>
                </ListItemIcon>
              </ListItemButton>

            </List>
          </Grid>
        </Grid>
      </Dialog>
    </React.Fragment>
  );
}

export default RoleUserPartcListDialog